<template>
  <!--begin::Menu wrapper-->
  <div
    id="kt_aside_menu_wrapper"
    ref="scrollElRef"
    class="hover-scroll-overlay-y my-5 my-lg-5"
    data-kt-scroll="true"
    data-kt-scroll-activate="{default: false, lg: true}"
    data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
    data-kt-scroll-height="auto"
    data-kt-scroll-offset="0"
    data-kt-scroll-wrappers="#kt_aside_menu"
  >
    <!--begin::Menu-->
    <div
      id="#kt_header_menu"
      class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
      data-kt-menu="true"
    >
      <template v-for="(item, i) in MainMenuConfig">
        <div
          v-if="item.heading && checkSubMenuPermission(item.pages[0])"
          class="menu-item"
          :key="i"
        >
          <div class="menu-content pt-8 pb-2">
            <span class="menu-section text-muted text-uppercase fs-8 ls-1">
              {{ $t(item.heading.toUpperCase()) }}
            </span>
          </div>
        </div>
        <template v-for="(menuItem, j) in item.pages" :key="j">
          <template v-if="menuItem.heading">
            <div class="menu-item">
              <router-link
                v-if="checkMainMenuPermission(menuItem.allowedPermission)"
                class="menu-link"
                @click="resetSideBarToggle()"
                :class="{ active: hasActiveChildren(menuItem.route) }"
                active-class="active"
                :to="menuItem.route"
              >
                <span
                  v-if="menuItem.svgIcon || menuItem.fontIcon"
                  class="menu-icon"
                >
                  <i
                    v-if="asideMenuIcons === 'font'"
                    :class="menuItem.fontIcon"
                    class="bi fs-3"
                  ></i>
                  <span
                    v-else-if="asideMenuIcons === 'svg'"
                    class="svg-icon svg-icon-2"
                  >
                    <inline-svg :src="menuItem.svgIcon" />
                  </span>
                </span>
                <span class="menu-title">{{
                  $t(menuItem.heading.toUpperCase())
                }}</span>
              </router-link>
            </div>
          </template>

          <div
            v-if="menuItem.sectionTitle && checkSubMenuPermission(menuItem)"
            :class="{ show: menuItem.sectionKey == route.meta.section }"
            class="menu-item mainmenu menu-accordion"
            data-kt-menu-sub="accordion"
            data-kt-menu-trigger="click"
          >
            <span class="menu-link">
              <span
                v-if="menuItem.svgIcon || menuItem.fontIcon"
                class="menu-icon"
              >
                <i
                  v-if="asideMenuIcons === 'font'"
                  :class="menuItem.fontIcon"
                  class="bi fs-3"
                ></i>
                <span
                  v-else-if="asideMenuIcons === 'svg'"
                  class="svg-icon svg-icon-2"
                >
                  <inline-svg :src="menuItem.svgIcon" />
                </span>
              </span>

              <span class="menu-title">{{
                $t(menuItem.sectionTitle.toUpperCase())
              }}</span>
              <span class="menu-arrow"></span>
            </span>
            <div
              :class="{ show: hasActiveChildren(menuItem.route) }"
              class="menu-sub submenu menu-sub-accordion"
            >
              <template v-for="(item2, k) in menuItem.sub" :key="k">
                <div v-if="item2.heading" class="menu-item">
                  <router-link
                    :class="{ active: hasActiveChildren(item2.route) }"
                    v-if="checkMainMenuPermission(item2.allowedPermission)"
                    class="menu-link"
                    exact-active-class="active"
                    :to="item2.route"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{
                      $t(item2.heading)
                    }}</span>
                  </router-link>
                </div>
                <div
                  v-if="item2.sectionTitle"
                  :class="{ show: hasActiveChildren(item2.route) }"
                  class="menu-item menu-accordion"
                  data-kt-menu-sub="accordion"
                  data-kt-menu-trigger="click"
                >
                  <span class="menu-link">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{
                      $t(item2.sectionTitle.toUpperCase())
                    }}</span>
                    <span class="menu-arrow"></span>
                  </span>
                  <div
                    :class="{ show: hasActiveChildren(item2.route) }"
                    class="menu-sub menu-sub-accordion"
                  >
                    <template v-for="(item3, k) in item2.sub">
                      <div v-if="item3.heading" class="menu-item" :key="k">
                        <router-link
                          class="menu-link"
                          active-class="active"
                          :to="item3.route"
                        >
                          <span class="menu-bullet">
                            <span class="bullet bullet-dot"></span>
                          </span>
                          <span class="menu-title">{{
                            $t(item3.heading.toUpperCase())
                          }}</span>
                        </router-link>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </template>
    </div>
    <!--end::Menu-->
  </div>
  <!--end::Menu wrapper-->
</template>
<script>
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { useLoggedInUserRoles, useLoggedInUserPermissions } from "@/composable/global-functions.js";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = (ref < null) | (HTMLElement > null);

    const resetSideBarToggle = () => {
      let menuItemClass = document.querySelectorAll(".mainmenu");
      for (var i = 0; i < menuItemClass.length; i++) {
        menuItemClass[i].setAttribute("class", "menu-item mainmenu menu-accordion");
      }
      let menuItemSubClass = document.querySelectorAll(".submenu");
      for (var j = 0; j < menuItemClass.length; j++) {
        menuItemSubClass[j].setAttribute("class", "menu-sub submenu menu-sub-accordion");
      }
    };

    onMounted( async () => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    //Set active menu
    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    //Show the main menu if user have appropriate roles and permissions
    const checkMainMenuPermission = (permission) => {
      let role = useLoggedInUserRoles();
      let per = useLoggedInUserPermissions();
      let allowedPermission = [];
      if (per != null && typeof permission != "undefined") {
        allowedPermission = permission.filter(value => per.includes(value));
      }
      if (permission == null || role == "Super Admin" || allowedPermission.length > 0) {
        return true;
      } else {
        return false;
      }
    };

    //Show the sub menu if user have appropriate roles and permissions
    const checkSubMenuPermission = (params) => {
      let role = useLoggedInUserRoles();
      let per = useLoggedInUserPermissions();
      let mapedPermissions = params.sub.map(function (el) {
        return el.allowedPermission;
      });
      let allowedPermissions = [];
      mapedPermissions.forEach((value) => {
        if (per != null) {
          per.forEach((value1) => {
            if (value.includes(value1)) {
              allowedPermissions.push(value1);
            }
          });
        }
      });
      let result = (allowedPermissions.length > 0) ? true : false;
      if (role == "Super Admin") {
        return true;
      } else {
        return result;
      }
    };

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      route,
      checkMainMenuPermission,
      checkSubMenuPermission,
      resetSideBarToggle,
    };
  },
});
</script>
